<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-solid">
        <div class="box-body">
          <table class="table table-condensed">
            <tbody>
              <tr>
                <th>{{ $t('trainings.name') }}</th>
                <th width="20%"></th>
                <th width="25%"></th>
              </tr>
              <tr
                v-for="training in camp.trainings"
                :key="training.id">
                <td>
                  <a :href="'../programs/' + training.id">
                    {{getSportProgramName(training.name, training.name[$root.$i18n.locale])}}
                  </a>
                </td>
                <td>
                  <a class="preview-link" target="_blank"
                       :href="'https://sportlane.com/'+$root.$i18n.locale+'/programs/' + training.id + '?nocache=true'">
                    {{ $t('trainings.description.preview') }}
                  </a>
                </td>
                <td>
                  <label class="pull-right">
                    <input type="checkbox" id="isPublish" :value="training.isPublish"
                           v-on:change="updatePublishState(training)" name="isPublish" v-model="training.isPublish">
                    {{ $t('trainings.description.is-publish') }}
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="box-footer">
          <button type="submit" data-toggle="modal" v-on:click="selectCamp()" data-target="#modal-new-program" class="btn btn-info pull-right">
            {{$t('trainings.create-training')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProgramContent',
  props: {
    camp: Object,
    sportTypes: Array
  },
  data () {
    return {
      currentTraining: null
    };
  },
  methods: {
    getSportProgramName: function (name, currentValue) {
      if (name.ru === currentValue) {
        if (currentValue.length === 0) {
          return '----------';
        }

        return currentValue;
      }

      if (name.en === currentValue) {
        if (currentValue.length === 0) {
          return '----------';
        }

        return currentValue;
      }
    },
    selectCamp: function () {
      this.$root.$emit('selectCurrentCamp', this.camp);
    },
    isBackoffice: function () {
      return window.application !== 'cabinet';
    },
    setCurrentTraining: function (training) {
      this.$root.$emit('selectCurrentTraining', training);
    },
    openFaqs: function (training) {
      this.$root.$emit('selectCurrentTraining', training);
      this.$root.$emit('showFaqs', training.id, training.camp.id);
    },
    updatePublishState: function (training) {
      var self = this;

      var trainingId = training.id;

      console.log(training);

      var q = [];

      if (training.qualificationAmateur) {
        q.push(1);
      }

      if (training.qualificationProfessional) {
        q.push(2);
      }

      axios.get(
        window.host + '/sport-programs/' + trainingId)
        .then(function (response) {
          var savedTraining = response.data;

          savedTraining.isPublish = training.isPublish;

          axios.put(
            window.host + '/sport-programs/' + trainingId, savedTraining)
            .then(function (response) {
              console.log(response.data);
              self.$root.$emit('alert', 'success', 'alert.success');
            })
            .catch(function (error) {
              console.log(error);
              self.$root.$emit('alert', 'error', 'alert.error');
            });
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
};

</script>

<style scoped>
.modal-dialog{
  width: 80%;
}
  .preview-link{
    margin-left: 0;
    color: #777777;
    text-decoration: underline;
  }

  .info-box-content{
    color: #333;
  }
</style>
